import { lazy } from "react";
import { withSuspense } from "./routeHelpers";

const Reports = lazy(
  () => import(/* webpackChunkName: "reports" */ "../Reports/Reports")
);

export default [
  {
    path: "/reports",
    element: withSuspense(Reports),
  },
];
